module.exports = __webpack_public_path__ + "static/media/footer_3.a521d328.png";